import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useNotificationDetails = defineStore("notification", {
  state: () => ({
    notificationList: [],
    loadNotification: false,
  }),
  getters: {},
  actions: {
    async getNotificationData(params) {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.NOTIFICATION(params.page, params.per_page)
        );
        if (params.page == 1) {
          this.resetNotificationData();
        }
        if (response.data) {
          Array.prototype.push.apply(
            this.notificationList,
            response.data.items
          );
          this.loadNotification = true;
          this.notificationList.sort((a, b) => {
            var dateA = new Date(a.created_at.replace(" ", "T")).getTime();
            var dateB = new Date(b.created_at.replace(" ", "T")).getTime();
            return dateA < dateB ? 1 : -1;
          });
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
        showError(error.message);
      }
    },
    resetNotificationData() {
      this.notificationList = [];
      this.loadNotification = false;
    },
    async getGiftDetail(id, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_DETAIL(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_DETAIL(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data) {
            return response.data;
          }
          return {};
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },

    async trackNotificationForTypePPlus(notificationType, id) {
      try {
        if (notificationType && id) {
          console.log(
            `Call Api for track notification with type ${notificationType} and id ${id}`
          );
          await this.$request.get(
            `${this.apiEndpoints.PPLUS_NOTIFICATION_TRACK}/${notificationType}/${id}`
          );
        } else {
          console.log(
            `Can not call Api for track notification because type is ${notificationType} and id is ${id}`
          );
        }
      } catch (error) {}
    },
    // Reports a push campaign open; ref_id and account_id are passed as they
    // arrive in the notification payload.
    async trackPushCampaignClick(refId, accountId) {
      try {
        if (refId && accountId) {
          await this.$request.post(this.apiEndpoints.PUSH_CAMPAIGN_CLICK, {
            ref_id: refId,
            account_id: accountId,
          });
        }
      } catch (error) {}
    },
    // Tracks a push campaign open at most once per campaign on this device.
    // A customer receives each campaign only once, so ref_id is the dedupe key;
    // this stops reloads / back navigation / post-login re-entry from recounting.
    async trackPushCampaignOpen(payload) {
      if (
        payload?.type?.toLowerCase() != "push campaign" ||
        !payload?.ref_id ||
        !payload?.account_id
      ) {
        return;
      }
      const key = "trackedPushCampaigns";
      const refId = String(payload.ref_id);
      let tracked = [];
      try {
        tracked = JSON.parse(localStorage.getItem(key)) || [];
      } catch (error) {}
      if (tracked.includes(refId)) return;

      // Mark before the call so a second trigger in flight is ignored.
      tracked = [...tracked, refId].slice(-50);
      try {
        localStorage.setItem(key, JSON.stringify(tracked));
      } catch (error) {}

      await this.trackPushCampaignClick(payload.ref_id, payload.account_id);
    },
    async markOnlineDiscountPushRead(processId, storeId) {
      try {
        if (processId && storeId) {
          await this.$request.get(
            this.apiEndpoints.ONLINE_DISCOUNT_PUSH_READ(processId, storeId)
          );
        }
      } catch (error) {}
    },
  },
});
